import { Competitor, StoreCompetitor } from '@retail/retailer/types';
import { useMemo } from 'react';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { alphabeticSort } from '@shared/utils';
import { useFetchCompetitors } from './competitorsApi';

export const useSelectedCompetitors = (): Competitor[] => {
  const { selectedOrgUnitAssortment } = useSelectedOrgUnit();
  const { data: competitorsDto = [] } = useFetchCompetitors(selectedOrgUnitAssortment.orgUnitId);
  const { retailerLogoBaseUrl } = useMgPrisConfig();

  return useMemo(() => {
    return competitorsDto
      .map((dto) => StoreCompetitor.fromStoreDto(dto, retailerLogoBaseUrl))
      .sort(alphabeticSort<Competitor>('name'));
  }, [competitorsDto, retailerLogoBaseUrl]);
};
